import { AnyObject } from '@triare/auth-redux';
import { User } from '../../store/auth';
import {
  DefaultFetchError, FetchGet, FetchGetId, PagingDataResponse, PagingParams, useFetchGet, useFetchGetId,
} from '../fetch';

export type LogEntityType = 'users' | 'emails' | 'businesses' | 'tariffs' | 'settings';
export enum LogEntityEnum {
  users = 'Users',
  emails = 'Emails',
  businesses = 'Businesses',
  tariffs = 'Tariffs',
  settings = 'Settings',
}
export type ActionType = 'created' | 'modified' | 'deleted' | 'sent';
export enum ActionEnum {
  'created' = 'Created',
  'modified' = 'Modified',
  'deleted' = 'Deleted',
  'sent' = 'Sent',
}

export interface LogItem {
  id: string;
  timestamp: number; // або string і дата, з поправленим іменем;
  action: ActionType;
  user: User; // performedBy
  entityType: LogEntityType;
  requestUrl: string;
  requestToMbs: {
    body: AnyObject;
    query: AnyObject;
  } | null;
  before: AnyObject;
  after: AnyObject;
  createdAt: string;
}

export interface LogTableRow extends LogItem {
  key: string;
}

export interface LogGetParams extends PagingParams, Partial<Pick<LogItem, 'entityType' | 'action'>> {
  orderByColumn?: keyof Pick<LogItem, 'entityType' | 'action'>;
}

// requests:
export const useLogsGet = <DD = PagingDataResponse<LogItem>>(
  decorateData?: (data: PagingDataResponse<LogItem>) => DD,
): FetchGet<
  PagingDataResponse<LogItem>,
  LogGetParams,
  DefaultFetchError,
  DD
> => useFetchGet('admin-audit-logs', {
    autoStart: false,
    startStateLoading: false,
    decorateData,

  });

export const useLogGetById = (
  id?: string,
): FetchGetId<LogItem, DefaultFetchError, unknown> => useFetchGetId('admin-audit-logs', id, { autoStart: !!id });

export interface LogsTableData {
  data: LogTableRow[];
  total: number;
}

export const useLogsTableGet = () => useLogsGet<LogsTableData>(
  ({ data, meta }: PagingDataResponse<LogItem>): LogsTableData => ({
    data: data.map((item) => ({
      key: item.id,
      ...item,
    })),
    total: meta.itemCount,
  }),
);
